module.exports = __webpack_public_path__ + "img/CECA_CD8Tex.16e5bc01.png";